export default __webpack_public_path__ + "static/media/1918.e3fb4081.png";